/**
 * Global App Constant.
 */

export default {
  defaultTableRows: 20
}
